import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux"
//UI
import { Table, Segment, Header, Button, Input, Message, Icon, Form } from "semantic-ui-react";
import CircularProgress from "@material-ui/core/CircularProgress";
import "../../styles/common.css";
import { scrollToTop } from "../../resources/utils";
import { fetchYachts } from "../../../redux/actions/catalogs/yacht/fetchYachts";
import { initialStateYacht } from "../../../redux/actions/catalogs/yacht/fetchYacht";
import { fetchAdvanceCruises, initialStateAdvanceCruise } from "../../../redux/actions/reservations/advanceCruise/fetchAdvanceCruises";
import { generateAdvanceCruiseReport, initialStateAdvanceCruiseReport } from "../../../redux/actions/reservations/advanceCruise/generateAdvanceCruiseReport";
import { useForm } from "react-hook-form";

export default function AdvanceCruiseList() {
  const { t } = useTranslation();
  const { register, handleSubmit, errors } = useForm();
  const yachtState = useSelector((state) => state.yachtsReducer);
  const advanceCruiseState = useSelector((state) => state.advanceCruiseReducer);
  const advanceCruiseReportState = useSelector((state) => state.advanceCruiseReportReducer);
  const [advanceCruise, setAdvanceCruise] = useState({});
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [cruiseYacht, setCruiseYacht] = useState("")
  const [cruiseYachtId, setCruiseYachtId] = useState("")


  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(fetchYachts());
    scrollToTop();
    return () => {
      dispatch(initialStateYacht());
      dispatch(initialStateAdvanceCruise());
      dispatch(initialStateAdvanceCruiseReport());
    };
  }, []);

  if (advanceCruiseState.fetching || yachtState.fetching) {
    return <CircularProgress />;
  }

  const onSubmit = (data) => {
    setAdvanceCruise(data)
    dispatch(fetchAdvanceCruises(data.yacht_id, data.start_date, data.end_date));
  };

  const handleGenerateReport = () => {
    dispatch(
      generateAdvanceCruiseReport(
        advanceCruise.yacht_id,
        advanceCruise.start_date,
        advanceCruise.end_date
      )
    );
  };

  return (
    <>
      {advanceCruiseState.error ? (
        <Message negative content={t(advanceCruiseState.error)} />
      ) : (
        ""
      )}
      <Segment className="flex items-center justify-between">
        <div className="ui breadcrumb">
          <div className="active section text-lg">{t("advance_report_title")} </div>
        </div>
        <Header as='h5' floated='right' className="flex items-center gap-2">
          <Form onSubmit={handleSubmit(onSubmit)} className="flex gap-1">
            <div className="flex flex-col">
              <label className="text-gray-500">{t("advance_report_yacht")}</label>
              <select name="yacht_id" className="ui selection dropdown font-normal" aria-expanded="true"
                style={{ padding: '3px 5px' }}
                ref={register({ required: true })}
                defaultValue={cruiseYachtId}
                onChange={
                  e => {
                    setCruiseYachtId(e.target.value)
                    setCruiseYacht(e.target.selectedOptions[0].getAttribute('data-name'))
                  }

                }
              >
                <option></option>
                {yachtState.yachts.map((yacht) => (
                  <option key={yacht.id} value={yacht.id} data-name={yacht.name}>{yacht.name}</option>
                ))}
              </select>
              {errors.yacht_id && (<span className="error_message">{t("required_information")}</span>)}
            </div>
            <Input type="date" className="flex flex-col">
              <label className="font-semibold text-gray-500">{t("statistic_startDate")}</label>
              <input
                value={startDate}
                onChange={e => setStartDate(e.target.value)}
                name="start_date"
                ref={register({ required: true })}
              />
              {errors.start_date && (<span className="error_message">{t("required_information")}</span>)}
            </Input>
            <Input type="date" className="flex flex-col">
              <label className="font-semibold text-gray-500">{t("statistic_endDate")}</label>
              <input
                value={endDate}
                onChange={e => setEndDate(e.target.value)}
                name="end_date"
                ref={register({ required: true })}
              />
              {errors.end_date && (<span className="error_message">{t("required_information")}</span>)}
            </Input>
            <div className="flex mt-[17px]">
              <Button
                type="submit"
                className={
                  advanceCruiseState.fetching
                    ? "ui loading primary button"
                    : "ui primary button"
                }>
                <Icon name="file alternate" />
                {t("generate_report_button")}

              </Button>
              <Button
                onClick={() => handleGenerateReport()}
                type="button"
                className={
                  advanceCruiseReportState.fetching
                    ? "ui loading primary button"
                    : "ui primary button"
                } style={{ backgroundColor: "#1BB394", color: "white" }}>
                <Icon name="file excel" />
                {t("excel_button")}
              </Button>
            </div>
          </Form>
        </Header>
      </Segment>
      <Segment className="flex flex-col items-center justify-center">
        <h2 className="uppercase text-gray-500">{t("advance_report_title")}{cruiseYacht && ` - ${cruiseYacht}`}</h2>
      </Segment>
      <Table color="blue" striped>
        <Table.Header align="left">
          <Table.Row>
            <Table.HeaderCell>{t("advance_report_reservation")}</Table.HeaderCell>
            <Table.HeaderCell>{t("advance_report_start")}</Table.HeaderCell>
            <Table.HeaderCell>{t("advance_report_end")}</Table.HeaderCell>
            <Table.HeaderCell width="100px">{t("advance_report_name")}</Table.HeaderCell>
            <Table.HeaderCell>{t("advance_report_total")}</Table.HeaderCell>
            <Table.HeaderCell>{t("advance_report_pp")}</Table.HeaderCell>
            <Table.HeaderCell>{t("advance_report_sp")}</Table.HeaderCell>
            <Table.HeaderCell>{t("advance_report_guide_one")}</Table.HeaderCell>
            <Table.HeaderCell>{t("advance_report_lang_one")}</Table.HeaderCell>
            <Table.HeaderCell>{t("advance_report_guide_two")}</Table.HeaderCell>
            <Table.HeaderCell>{t("advance_report_lang_two")}</Table.HeaderCell>
            <Table.HeaderCell>{t("advance_report_captain")}</Table.HeaderCell>
            <Table.HeaderCell width="250px">{t("advance_report_notes")}</Table.HeaderCell>
          </Table.Row>
        </Table.Header>
        <Table.Body align="left">
          {advanceCruiseState.cruises.map((cruise) => (
            <Table.Row key={cruise.id}>
              <Table.Cell>{cruise.code}</Table.Cell>
              <Table.Cell>{cruise.start_date_format}</Table.Cell>
              <Table.Cell>{cruise.end_date_format}</Table.Cell>
              <Table.Cell>{cruise.name}</Table.Cell>
              <Table.Cell align="center">{cruise.TO}</Table.Cell>
              <Table.Cell align="center">{cruise.PP}</Table.Cell>
              <Table.Cell align="center">{cruise.SP}</Table.Cell>
              <Table.Cell>{cruise.guide1}</Table.Cell>
              <Table.Cell>{t(cruise.language1)}</Table.Cell>
              <Table.Cell>{cruise.guide2}</Table.Cell>
              <Table.Cell>{t(cruise.language2)}</Table.Cell>
              <Table.Cell>{cruise.captain}</Table.Cell>
              <Table.Cell>{cruise.notes}</Table.Cell>
            </Table.Row>
          ))}
        </Table.Body>
      </Table>
    </>
  );
}
